import mapleGrove from "@/assets/property-maple-grove.png";
import cedarLane from "@/assets/property-cedar-lane.png";
import birchCourt from "@/assets/property-birch-court.png";
import skyline from "@/assets/property-skyline.png";
import oakTerrace from "@/assets/property-oak-terrace.png";
import willowBrook from "@/assets/property-willow-brook.png";
import harborView from "@/assets/property-harbor-view.png";
import pineStreet from "@/assets/property-pine-street.png";

export const PROPERTY_IMAGES: Record<string, string> = {
  maple_grove_duplex: mapleGrove,
  cedar_lane_rental: cedarLane,
  birch_court_fixer: birchCourt,
  skyline_townhome: skyline,
  oak_terrace_fourplex: oakTerrace,
  willow_brook_starter: willowBrook,
  harbor_view_condo: harborView,
  pine_street_duplex: pineStreet,
};

export function getPropertyImage(propertyKey: string): string | undefined {
  return PROPERTY_IMAGES[propertyKey];
}
